import { Card, Col, Row, Typography } from "antd";
import React from "react";
import { IStats } from "../interfaces";
import { useNavigate } from "@tanstack/react-router";
import {
  CheckCircleOutlined,
  PlayCircleOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import moment from "moment";

interface IStatProps {
  today: IStats;
  overall: IStats;
}

const YoutubeStats = ({
  stats,
  length,
}: {
  stats: IStatProps;
  length: number;
}) => {
  const navigate = useNavigate();
  const { Title, Text } = Typography;

  const { today, overall } = stats || {};

  const todayData = moment().format("YYYY-MM-DD");

  const StatCard = ({
    title,
    value = 0,
    icon,
    color,
    url,
  }: {
    title: string;
    value?: number;
    icon: React.ReactNode;
    color: string;
    url?: any;
  }) => {
    return (
      <Col
        xs={24}
        sm={12}
        md={8}
        lg={6}
        xl={6}
        xxl={4.8}
        style={{ cursor: "pointer" }}
      >
        <Card
          style={{
            borderRadius: 14,
            border: "none",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
          bodyStyle={{ padding: 20 }}
          onClick={() => {
            navigate({ to: url });
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 10,
                background: `linear-gradient(135deg, ${color}18 0%, ${color}35 100%)`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: color,
                fontSize: 24,
                flexShrink: 0,
              }}
            >
              {icon}
            </div>
            <div style={{ flex: 1, minWidth: 0, overflow: "hidden" }}>
              <Text
                style={{
                  fontSize: 12,
                  color: "#6b7280",
                  marginBottom: 2,
                  display: "block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {title}
              </Text>
              <Title
                level={4}
                style={{
                  margin: 0,
                  color: "#1f2937",
                  fontSize: 22,
                  whiteSpace: "nowrap",
                }}
              >
                {value}
              </Title>
            </div>
          </div>
        </Card>
      </Col>
    );
  };

  return (
    <>
      <Row gutter={[24, 24]} wrap>
        <StatCard
          title="Total Videos"
          value={overall?.total}
          icon={<VideoCameraOutlined />}
          color="#0ea5e9"
          url={`/youtube`}
        />
        <StatCard
          title="Today Videos"
          value={today?.total}
          icon={<VideoCameraOutlined />}
          color="#0ea5e9"
          url={`/youtube?&date=${todayData}`}
        />
        <StatCard
          title="Active Live"
          value={today?.totalLive}
          icon={<PlayCircleOutlined />}
          color="#10b981"
          url={`/youtube?status=live&date=${todayData}`}
        />
        <StatCard
          title="Ended"
          value={today?.totalRendered}
          icon={<CheckCircleOutlined />}
          color="#8b5cf6"
          url={`/youtube?status=ended&date=${todayData}`}
        />
      </Row>
    </>
  );
};

export default YoutubeStats;
